import { defineMessages } from "react-intl";

export const boardBasisMessages = defineMessages({
  AI: {
    defaultMessage: "All inclusive",
    description:
      "Board basis option: all inclusive (all meals and drinks included)",
  },
  BB: {
    defaultMessage: "Bed & breakfast",
    description: "Board basis option: bed and breakfast",
  },
  FB: {
    defaultMessage: "Full board",
    description: "Board basis option: full board (all meals included)",
  },
  HB: {
    defaultMessage: "Half board",
    description: "Board basis option: half board (breakfast and dinner)",
  },
  RD: {
    defaultMessage: "Checkroom available",
    description: "Board basis option: checkroom / luggage storage available",
  },
  RO: {
    defaultMessage: "Room Only",
    description: "Board basis option: room only (no meals included)",
  },
  SC: {
    defaultMessage: "Self catering",
    description: "Board basis option: self catering",
  },
});

export function isKnownBoardBasis(
  value: string,
): value is keyof typeof boardBasisMessages {
  return Object.keys(boardBasisMessages).includes(value);
}
